// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"60":"e55da948","82":"c741ba2e","188":"365f9543","353":"f9afd56a","462":"577c0f0d","473":"2f10d1e0","501":"e6ac239b","553":"c4aa5f46","662":"e8b2b26e","750":"4489de9b","919":"41bb5220","964":"7166d567"}[chunkId] + ".chunk.js";
};